import { Dispatch, SetStateAction, useState } from "react"
import styles from "./EntrepreneurAddOrEditProduct.module.css";
import { Specifications } from ".";

interface ModalProps {
    closeModal: () => void
    specifications: Specifications[]
    setSpecifications: Dispatch<SetStateAction<Specifications[]>>
}

export function Modal({ closeModal, setSpecifications, specifications }: ModalProps) {
    const [formData, setFormData] = useState<Specifications>({ specification: '', description: '' });
    const [error, setError] = useState<string | null>(null)
    const [errorOnEdit, setErrorOnEdit] = useState<string | null>(null)
    const [specSelected, setSpecSelected] = useState(-1)

    function handleChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
        const { name, value } = event.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    function handleChangeEdit(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, idx: number) {
        const { name, value } = event.target;
        setSpecifications((prev) => {
            const updatedSpec = [...prev]
            updatedSpec[idx] = {
                ...prev[idx],
                [name]: value
            }
            return updatedSpec
        });
    };

    function deleteSpecifications(idx: number) {
        const aux = [...specifications].filter((_, index) => index !== idx)
        setSpecifications(aux)
    }

    function addSpecification(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()
        setError(null)
        if (formData.description === "" || formData.specification === "") return

        const specAlreadyExist = specDuplicate(formData.specification)

        if (specAlreadyExist) {
            setError("Especifação já adicionada")
            return
        }

        const spec: Specifications = {
            description: formData.description,
            specification: formData.specification,
        }
        setSpecifications(prevValue => {
            return [...prevValue, spec]
        })
        setFormData({
            description: "",
            specification: ""
        })
    }

    function specDuplicate(spec: string, idx: number = -1): boolean {
        const specAlreadyExist = specifications.find((specefication, index) => specefication.specification === spec && index !== idx)
        return specAlreadyExist ? true : false
    }

    return (
        <div style={{
            position: 'absolute', zIndex: 50, display: 'flex', flex: 1, width: '100%', backgroundColor: '#FAFAFA', borderWidth: 1, borderColor: 'rgba(0,0,0,0.25)', borderStyle: 'solid', borderRadius: 8, alignItems: 'center', justifyContent: 'center', padding: '32px 40px', flexDirection: 'column'
        }}>
            <span onClick={() => {
                if(errorOnEdit !== null) setErrorOnEdit("Não pode ter especificações duplicadas")
                    else closeModal()
            }} className={styles.closeModal} style={{ alignSelf: 'flex-end', fontSize: 24 }}>X</span>
            <h1 style={{ color: "#D8372C", fontSize: 32 }}>Adicionar Informações Técnicas</h1>

            <div style={{ width: "100%", display: 'flex', flexDirection: 'column', gap: 8, marginTop: 40 }}>
                {specifications.map((spec, idx) => (
                    <div key={idx} style={{ alignSelf: 'center', width: '50%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <div onClick={() => setSpecSelected(idx)} className={styles.spec}
                            style={{ alignSelf: 'center', display: 'flex', width: "100%", flexDirection: 'row', justifyContent: 'flex-start', padding: "4px 12px", gap: 8, backgroundColor: '#DBDBDB', fontSize: 24, fontWeight: '500' }}
                        >
                            <span className={styles.deleteSpecifications} onClick={() => deleteSpecifications(idx)}>X</span>
                            {idx !== specSelected ? <span>{spec.specification}</span> : <input onClick={() => setSpecSelected(idx)} className={styles.spec} id="specification" name="specification" value={spec.specification} onChange={(e) => handleChangeEdit(e, idx)}
                                style={{ border: 'none', fontSize: 20, padding: "0 8px"}}
                                onBlur={() => {
                                    setErrorOnEdit(null)
                                    const specAlreadyExist = specDuplicate(spec.specification, idx)
                                    if(specAlreadyExist) setErrorOnEdit("Especifação já adicionada")
                                }}
                            />}
                        </div>
                        <textarea name="description" id="description" className={styles.specDesc} style={{ display: specSelected === idx ? 'flex' : 'none', width: '100%', padding: "8px", resize: 'none', marginTop: 8 }} rows={3} value={spec.description} onChange={(e) => handleChangeEdit(e, idx)} />
                    </div>
                ))}
                <span style={{ color: '#D8372C' }}>{errorOnEdit}</span>
            </div>


            <form onSubmit={addSpecification} style={{ display: 'flex', width: '100%', flexDirection: 'column', gap: 24, padding: '0 80px', marginTop: 40 }}>
                <div style={{ display: 'flex', flex: 1, flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', gap: 8 }}>
                    <label htmlFor="specification"
                        style={{
                            fontSize: 20, fontWeight: '400'
                        }}>Adicionar especificação:</label>
                    <input name="specification" id="specification" type="text" value={formData.specification} onChange={handleChange} style={{ marginTop: 8, padding: '8px 2px 8px 16px', borderRadius: 10, borderColor: 'rgba(0,0,0,0.25)', width: "40%", height: 40 }} />
                </div>
                <div style={{ display: 'flex', flex: 1, flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', gap: 8 }}>
                    <label htmlFor="description"
                        style={{
                            fontSize: 20, fontWeight: '400'
                        }}>Adicionar descrição:</label>
                    <textarea name="description" id="description" value={formData.description} onChange={handleChange} style={{ marginTop: 8, padding: '8px 2px 8px 16px', borderRadius: 10, borderColor: 'rgba(0,0,0,0.25)', width: "40%", height: 40 }} />
                </div>

                <span style={{ color: '#D8372C' }}>{error}</span>

                <button type="submit" className={styles.modalButton}
                    style={{
                        padding: "0.8rem 16px",
                        borderRadius: 10,
                        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                        color: "black",
                        fontWeight: "600",
                        fontSize: "1.2rem",
                        cursor: "pointer",
                        width: "50%",
                        alignSelf: 'center',
                        transition: "background-color 0.3s",
                        margin: "2rem 0px",
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        gap: 12,
                    }}>
                    <span style={{
                        display: 'flex',
                        alignItems: 'flex-end',
                        justifyContent: 'center',
                        width: 24,
                        height: 24,
                        borderWidth: 1,
                        borderStyle: 'solid',
                        borderColor: 'black',
                        borderRadius: 9999,
                        boxSizing: 'border-box',
                        textAlign: 'center'
                    }}
                    >+</span> Adicionar Informação Técnica
                </button>
            </form>
        </div >
    )
}